export const SANITY_PROJECT_ID = 'ivaqw3e8';
